import * as React from 'react';
import * as Edge from '../../../core';
import ExerciseResultLayout from '../exerciseResultLayout';
import { ExerciseMetadataService } from '../../../services/exerciseMetadataService';

export interface TrackingResultsProps {
	results: Edge.Models.TrackingExerciseResult;
	completeText: string;
	retry: () => void;
	complete: () => void;
	hideExerciseResults: boolean;
}

export class TrackingResults extends React.PureComponent<TrackingResultsProps> {
	constructor(props: TrackingResultsProps) {
		super(props);
		this.state = {};
	}
	public render() {
		const { complete, completeText, results, retry, hideExerciseResults } = this.props;
		const exercise = ExerciseMetadataService.getMetadata(results);
		return (
			<ExerciseResultLayout
				className="tracking_results"
				exerciseName="Tracking"
				description={exercise && exercise.description}
				headerActions={
					<>
						<button className="cta_btn" onClick={retry}>
							Retry Exercise
						</button>
						<button className="cta_btn" onClick={complete}>
							{completeText}
						</button>
					</>
				}
				results={[results]}
				hideExerciseResults={hideExerciseResults}
			/>
		);
	}
}

export default TrackingResults;
